<script setup lang="ts">
import { FuelTypeCount, VehicleCountData } from '~/types/statistics'
import { LineDataset } from '~/types/types'

const props = defineProps<{ graphData: VehicleCountData[] }>()
const { mapKeysToColors } = useColors()

const labels = computed(() => getLabels(props.graphData))
const formattedDatasets = computed(() => formatChartData(props.graphData))

function getLabels(data: VehicleCountData[]) {
  return data.map((item) => item.year)
}
function formatChartData(data: VehicleCountData[]) {
  const datasets: LineDataset[] = []

  // Extract all keys from the total_count object
  const keys = Object.keys(data[data.length - 1].total_count)

  const colorKeys = mapKeysToColors(keys.sort())

  // Create a dataset for each key
  keys.forEach((key) => {
    const keyToUppercase = key.charAt(0).toUpperCase() + key.slice(1)
    const dataset = {
      label: keyToUppercase,
      fill: false,
      backgroundColor: colorKeys[key as string],
      borderColor: colorKeys[key as string],
      pointStyle: 'circle' as LineDataset['pointStyle'],
      pointRadius: 2,
      data: data.map((item) => {
        if (Object.keys(item.total_count).length === 0) {
          return 0 // Set data to 0 if empty
        }
        return item.total_count[key as keyof FuelTypeCount] // Extract data for the key
      }),
    }

    datasets.push(dataset)
  })

  return datasets
}
</script>

<template>
  <div class="chart-container">
    <ChartLine :labels="labels" :datasets="formattedDatasets" />
  </div>
</template>

<style scoped lang="css">
.chart-container {
  padding: 2rem 0;
}
</style>
